import localStorage from 'fc-storage'
import { MAP_URL_DEFAULT } from './constants'
import { initialState as spatialState } from 'fc-spatial'
import { BALTIC_SD_LATLON } from 'hfty-map/src/constants'
import { PROP_SOIL_PROPS_MAP_BLOB_ID } from 'hfty-map-dom/src/constants'

export default {
  ...spatialState,
  mapUrl: localStorage.getItem('hfty-map-url') || MAP_URL_DEFAULT,
  center: [43.76, -96.74], // Baltic, SD
  centerBbox: BALTIC_SD_LATLON,
  zoom: 6,
  selectedFarmId: null,
  selectedField: null,
  selectedFieldId: null,
  selectedSeasonId: null,
  selectedFeatureIndex: null,
  selectedJobId: null,
  hoverFeatureIndex: null,
  hoverSamplingPoint: null,
  featureOperations: {},
  panelToggled: true,
  selectedFeatureIndices: [],
  selectedSoilTestFilter: null,
  imageryLayerToggled: false,
  isPreviousPointsShown: true,
  [PROP_SOIL_PROPS_MAP_BLOB_ID]: null,
}
